/*
 * Hidden SVG defs holding the feColorMatrix filters referenced by
 * accessibility.css (body.a11y-cb-* { filter: url(#a11y-cb-*) }).
 * Rendered once at the app root. Matrices are standard CVD simulations.
 */
export default function ColorBlindFilters() {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
        >
            <defs>
                <filter id="a11y-cb-protanopia">
                    <feColorMatrix
                        type="matrix"
                        values="0.567 0.433 0 0 0
                                0.558 0.442 0 0 0
                                0 0.242 0.758 0 0
                                0 0 0 1 0"
                    />
                </filter>
                <filter id="a11y-cb-deuteranopia">
                    <feColorMatrix
                        type="matrix"
                        values="0.625 0.375 0 0 0
                                0.7 0.3 0 0 0
                                0 0.3 0.7 0 0
                                0 0 0 1 0"
                    />
                </filter>
                <filter id="a11y-cb-tritanopia">
                    <feColorMatrix
                        type="matrix"
                        values="0.95 0.05 0 0 0
                                0 0.433 0.567 0 0
                                0 0.475 0.525 0 0
                                0 0 0 1 0"
                    />
                </filter>
            </defs>
        </svg>
    );
}
